import React, { useState } from 'react';
import { TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Typography, Stack, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import SingleLotupdate from './singleLotupdate';

const LotUpdate = () => {
  const [invType, setInvType] = useState(null);


  

  return (
    <div>
      {/* <h2></h2> */}
      <Typography variant='h2'>Packet Update</Typography>
       <FormControl fullWidth sx={{mt:2}} >
                      <InputLabel>Select Type</InputLabel>
                      <Select onChange={e=>setInvType(e.target.value)} fullWidth placeholder='Select type' label={"Select type"} name='type'>
                        <MenuItem value={0}>Polish Single</MenuItem>
                        <MenuItem value={1}>Jewelry</MenuItem>
                      </Select>
                    </FormControl>
      {/* Search Input */}
      {invType == 0 && <SingleLotupdate />}
      {/* <Stack direction="row" spacing={2}>
      <TextField
        label="Stone ID"
        variant="outlined"
        value={stone}
        onChange={(e) => setStone(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleSearch}
        size='large'
        sx={{ px: 6 }}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : 'Search'}
      </Button>
</Stack> */}
      {/* Error Message */}
      {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}

      {/* Table to display stone history */}
      {/* {data.length > 0 && (
        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Transaction Date</TableCell>
                <TableCell>Party</TableCell>
                <TableCell>Stone ID</TableCell>
                <TableCell>Transaction Type</TableCell>
                <TableCell>Confirm CTS<sub>(PCS)</sub></TableCell>
                <TableCell>Return CTS<sub>(PCS)</sub></TableCell>
                <TableCell>Confirm/Return Date</TableCell>
                <TableCell>Rap Price</TableCell>
                <TableCell>Amt($)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{formatDate(row.TR_DATE)}</TableCell>
                  <TableCell>{row.PARTY}</TableCell>
                  <TableCell>{row.FL_STONE_ID}</TableCell>
                  <TableCell>{row.TR_TRTYPR}</TableCell>
                  <TableCell>{row.FL_KEPT_CTS}<sub>({row.FL_KEPT_PCS || '-'})</sub></TableCell>
                  <TableCell>{row.FL_RET_CTS}<sub>({row.FL_RET_PCS || '-'})</sub></TableCell>
                  <TableCell>{row.FL_RET_DATE && formatDate(row.FL_RET_DATE)}</TableCell>
                  <TableCell>{row.RAP}</TableCell>
                  <TableCell>{row.AMT?.toFixed(2)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )} */}

      {/* If no results */}
      {/* {data.length === 0 && !loading && <p>No data found</p>} */}
    </div>
  );
  
};
LotUpdate.Modulename = 'StoneSearch'
export default LotUpdate;
